import { render, staticRenderFns } from "./MaraTable.vue?vue&type=template&id=476af287&"
import script from "./MaraTable.vue?vue&type=script&lang=js&"
export * from "./MaraTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports